import { render, staticRenderFns } from "./MovementRouteLessonSectionSelect.vue?vue&type=template&id=1e910fb8&scoped=true"
import script from "./MovementRouteLessonSectionSelect.vue?vue&type=script&lang=js"
export * from "./MovementRouteLessonSectionSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e910fb8",
  null
  
)

export default component.exports